import { render, staticRenderFns } from "./sub-dep-dialog.vue?vue&type=template&id=3c916085&scoped=true&"
import script from "./sub-dep-dialog.vue?vue&type=script&lang=js&"
export * from "./sub-dep-dialog.vue?vue&type=script&lang=js&"
import style0 from "./sub-dep-dialog.vue?vue&type=style&index=0&id=3c916085&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c916085",
  null
  
)

export default component.exports